export default {
    // ----------Title----------
    configuration: 'Configuration',
    containerProps: 'Container Props',
    productProps: 'Product Props',
    itemProps: 'Item Props',
    customerProps: 'Customer Props',
    customerBranchProps: 'Customer Branch Props',
    deliveryOrderProps: 'Delivery Order Props',
    itemReceiveProps: 'Item Receive Props'
}